import { render, staticRenderFns } from "./DriverDetailsScreen.vue?vue&type=template&id=27ee0b3c&scoped=true&"
import script from "./DriverDetailsScreen.vue?vue&type=script&lang=js&"
export * from "./DriverDetailsScreen.vue?vue&type=script&lang=js&"
import style0 from "./DriverDetailsScreen.vue?vue&type=style&index=0&id=27ee0b3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ee0b3c",
  null
  
)

export default component.exports